import $ from 'jquery';
import _ from "underscore";

import ModalView from 'eoxc/src/core/views/ModalView';
import OpenLayersMapView from 'eoxc/src/contrib/OpenLayers/OpenLayersMapView';

import FiltersModel from 'eoxc/src/core/models/FiltersModel';
import HighlightModel from 'eoxc/src/core/models/HighlightModel';
import MapModel from 'eoxc/src/core/models/MapModel';
import LayersCollection from 'eoxc/src/core/models/LayersCollection';
import { isRecordDownloadable } from 'eoxc/src/download';
import { flattenDownloadSelectionByCoverage } from  'eoxc/src/download/url';
import LayerOptionsCoreView from 'eoxc/src/core/views/layers/LayerOptionsCoreView';

import template from './WPSModalView.hbs';

import './RecordsDetailsModalView.css';
import ProcessingPanelView from 'eoxc/src/download/views/ProcessingPanelView'

import '../lib/wps-js-all';
import { downloadCustom} from 'eoxc/src/download/'

const WPSModalView = ModalView.extend({
  template,

  className: 'record-details-modal-view modal fade',

  templateHelpers() {
    return {
    title: '',
    hasNext: this.currentRecordIndex < this.records.length - 1,
    hasPrev: this.currentRecordIndex > 0,
    hasMore: this.records.length > 1,
    };
  },

  events: {
    'click .records-next': 'onRecordsNextClicked',
    'click .records-prev': 'onRecordsPrevClicked',
    'shown.bs.modal': 'onModalShown',
    'change .is-selected': 'onDownloadSelectionChange',
    'click .processing-button' : 'onStartProcessing',
  },

  regions: {
    content: '.modal-body',
    'layer-options': '.layer-options',
  },

  initialize(options) {
      this.searchCollection = options.searchCollection;
    if (options.records) {
        this.records = options.records;
      } else {
        this.records = this.searchCollection.reduce((acc, searchModel) => (
          acc.concat(searchModel.get('downloadSelection')
            .map(recordModel => [recordModel, searchModel]))
        ), []);
      }
    this.records = _.uniq(flattenDownloadSelectionByCoverage(this.records))
    this.currentRecordIndex = 0;

    this.baseLayersCollection = options.baseLayersCollection;
    this.overlayLayersCollection = options.overlayLayersCollection;
    this.layersCollection = options.layersCollection;
    this.highlightFillColor = options.highlightFillColor;
    this.highlightStrokeColor = options.highlightStrokeColor;

    this.filterFillColor = options.filterFillColor;
    this.filterStrokeColor = options.filterStrokeColor;
    this.filterOutsideColor = options.filterOutsideColor;
    this.projection = options.projection;
    this.onError = options.onError;
    this.onLoading = options.onWaiting;

    this.mapModel = new MapModel({ center: [0, 0], zoom: 5, noclick: true, projection: this.projection });
    this.highlightModel = new HighlightModel();
    this.filtersModel = new FiltersModel();

    this.$el.sizeChanged(() => {
      this.updateResultsPanelSize();
    });

  },

  onModalShown() {
    this.updateRecord(...this.records[this.currentRecordIndex]);
    this.updateResultsPanelSize();
  },

  updateResultsPanelSize() {
    // resize results holding div based on variable footer and header sizes
    const restHeightCombined = $('.modal-header').outerHeight(true) + $('.modal-footer').outerHeight(true);
    $('.modal-body').height(`calc(100% - ${restHeightCombined}px)`);
  },

  updateRecord(recordModel, searchModel) {
    let time = recordModel.get('properties').time;
    if (time instanceof Date) {
      time = [time, time];
    }
    const layerModel = searchModel.get('layerModel');
    this.mapModel.set('time', time);
    this.mapView = new OpenLayersMapView({
      mapModel: this.mapModel,
      filtersModel: this.filtersModel,
      highlightModel: this.highlightModel,
      baseLayersCollection: this.baseLayersCollection,
      overlayLayersCollection: this.overlayLayersCollection,
      layersCollection: new LayersCollection([layerModel]),
      highlightFillColor: this.highlightFillColor,
      highlightStrokeColor: this.highlightStrokeColor,
      filterFillColor: this.filterFillColor,
      filterStrokeColor: this.filterStrokeColor,
      filterOutsideColor: this.filterOutsideColor,
      staticHighlight: true,
      useDetailsDisplay: true,
    });

    const detailsView = new ProcessingPanelView({
        processingModel:layerModel.get('wpsProcessing'),
        model: recordModel,
        mapModel: this.mapModel,
        mapView: this.mapView,
        descriptionTemplate: layerModel.get('search.descriptionTemplate'),
        headerText: 'Description of',
      });
    this.showChildView('content', detailsView);

    this.filtersModel.set('area', recordModel.attributes.geometry);

    this.mapModel.show(recordModel.attributes);
    this.highlightModel.highlight(recordModel.attributes);

    this.$('.modal-title').text(`${layerModel.get('displayName')} - ${time[0].toISOString()}`);
    this.$('.records-prev').toggleClass('disabled', !(this.currentRecordIndex > 0));
    this.$('.records-next').toggleClass('disabled', !(this.currentRecordIndex < this.records.length - 1));
    this.$('.current-record').text(this.currentRecordIndex + 1);
    this.$('.record-count').text(this.records.length);

    const downloadSelection = searchModel.get('downloadSelection');
    const isSelectedForDownload = downloadSelection.findIndex(model => (
      model.get('id') === recordModel.get('id')
    )) !== -1;
    this.$('.is-selected').prop('checked', isSelectedForDownload);
    this.$('.is-selected').parent().toggle(!!isRecordDownloadable(layerModel, recordModel));
    // because products were flattened to coverages, but here we can need original product ID for visualization 
    const modelCopyForDisplay = $.extend(true, {}, recordModel);
    modelCopyForDisplay.attributes.id = modelCopyForDisplay.attributes.itemID;
    this.showChildView('layer-options', new LayerOptionsCoreView({
      model: layerModel,
      useDetailsDisplay: true,
      recordModel: modelCopyForDisplay,
    }));

  },

  onRecordsPrevClicked() {
    if (this.currentRecordIndex > 0) {
      this.currentRecordIndex -= 1;
      this.updateRecord(...this.records[this.currentRecordIndex]);
    }
  },

  onRecordsNextClicked() {
    if (this.currentRecordIndex < this.records.length - 1) {
      this.currentRecordIndex += 1;
      this.updateRecord(...this.records[this.currentRecordIndex]);
    }
  },

  handleJson(response){
    if (typeof(response) === 'string'){
      response = JSON.parse(response)
    }
    return JSON.stringify(response)
  },

  onStartProcessing(){

    const [record, recordModel] = this.records[this.currentRecordIndex];
    const identifier = record.get('selectedProcess');
    if (identifier){
      this.onLoading();
      const WPSProcessSettings = recordModel.get('layerModel').get('wpsProcessing')
      let WPSInputs = [];
      let WPSOutputs = [];
      const inputGenerator = new InputGenerator();
      const outputGenerator = new OutputGenerator();

      const outputLookup = {
        "image/jpeg" : "jpg",
        "image/png" : "png",
        "image/tiff" : "tif",
        "text/csv" : "csv",
        "application/json": "json"
      }
      const wpsURL = Array.isArray(WPSProcessSettings.url) ? WPSProcessSettings.url[0] : WPSProcessSettings.url
      const wpsService = new WpsService({
        url: wpsURL,
        version: WPSProcessSettings.version
        });

        // inputs generation
      const requestOptions = record.get('requestOptions');

      Object.keys(requestOptions).filter(key => key !== 'outputs')
      .map( option => {
        let literalInput;
        if (option === 'bbox'){
          let bbox = requestOptions[option]
          literalInput = inputGenerator.createBboxDataInput_wps_1_0_and_2_0('bbox', null, null,`${bbox[0]} ${bbox[1]}` ,`${bbox[2]} ${bbox[3]}`)

        }else{
          literalInput = inputGenerator.createLiteralDataInput_wps_1_0_and_2_0(option, null, null, requestOptions[option]);
        }

        WPSInputs.push(literalInput)
      });


      // outputs generation
      Object.keys(requestOptions.outputs)
      .map( option => {
        let WPSComplexOutput = outputGenerator.createComplexOutput_WPS_2_0(option, requestOptions.outputs[option]);
        WPSOutputs.push(WPSComplexOutput)
      });

      const mediaType = WPSOutputs[0].mimeType;
      let document = this.$el.parent().parent()
      if (mediaType === 'application/json') wpsService.setMediaType('json')
      const response = ((response) => {
        let loading = document.find('.wps-loading')
        loading.remove();
       if(response.textStatus ==='error'){

        this.onError();

       }else {
        const content = mediaType === 'application/json'? this.handleJson(response.responseDocument): response.responseDocument;
        downloadCustom('wps_result.' + outputLookup[mediaType], mediaType, content);
       }

      })

      wpsService.execute(response, identifier, "raw", "sync", false, WPSInputs, WPSOutputs);
    }

  },

  removeRecord(){
    this.records = this.records.filter(record => record != this.records[this.currentRecordIndex])
    this.currentRecordIndex -= 1;
    if (this.records.length < 1){
      this.close();
    }else{
      this.onRecordsNextClicked();
    }


  },

  onDownloadSelectionChange() {
    const [recordModel, searchModel] = this.records[this.currentRecordIndex];
    const downloadSelection = searchModel.get('downloadSelection');
    if (this.$('.is-selected').is(':checked')) {
      downloadSelection.add(recordModel);
    } else {
      downloadSelection.remove(recordModel);
    }
  },
});

export default WPSModalView;



// WEBPACK FOOTER //
// /src/views/WPSModalView.js